import { IAppState } from '../../redux';
import { EOfferStatus } from '../../redux/reducers';

export function selectIsPublishedOffer(state: IAppState): boolean {
  const {
    offer: { id, status },
  } = state;

  return !!id && status === EOfferStatus.published;
}
